import { render, staticRenderFns } from "./StatusAlt.vue?vue&type=template&id=1977ae34&"
import script from "./StatusAlt.vue?vue&type=script&lang=js&"
export * from "./StatusAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports